import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Support = (props: Icon): React.ReactElement =>
  props.variant === "line" ? (
    <svg
      style={{ ...style(props.size), ...props.style }}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
    >
      <defs>
        <path
          d="M12 4a8 8 0 017.997 7.797L20 12v3.333a3.334 3.334 0 01-3.189 3.33l-.144.004h-2.781a2 2 0 110-1.334h2.78a2 2 0 001.997-1.882l.004-.118V12a6.667 6.667 0 00-13.331-.187L5.333 12v.667a.667.667 0 01-1.329.077L4 12.667V12a8 8 0 018-8zm0 13.333a.667.667 0 100 1.334.667.667 0 000-1.334zm-3.333-8a2 2 0 012 2V14a2 2 0 11-4 0v-2.667a2 2 0 012-2zm6.666 0a2 2 0 012 2V14a2 2 0 11-4 0v-2.667a2 2 0 012-2zm-6.666 1.334a.666.666 0 00-.667.666V14a.666.666 0 101.333 0v-2.667a.666.666 0 00-.666-.666zm6.666 0a.666.666 0 00-.666.666V14A.666.666 0 1016 14v-2.667a.666.666 0 00-.667-.666z"
          id="a-support"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="b-support" fill={props.color || theme.palette.grey600}>
          <use xlinkHref="#a-support" />
        </mask>
        <use
          fill={props.color || theme.palette.grey600}
          fillRule="nonzero"
          xlinkHref="#a-support"
        />
        <g
          mask="url(#b-support)"
          fill={props.color || theme.palette.grey600}
          fillOpacity=".6"
        >
          <path d="M0 0h24v24H0z" />
        </g>
      </g>
    </svg>
  ) : (
    <svg
      style={{ ...style(props.size), ...props.style }}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
    >
      <defs>
        <path
          d="M7.99999997,9.99999999 C7.26466664,9.99999999 6.66666663,10.598 6.66666663,11.3333333 L6.66666663,14.6666667 C6.66666663,15.402 7.26466664,16 7.99999997,16 C8.73533331,16 9.33333332,15.402 9.33333332,14.6666667 L9.33333332,11.3333333 C9.33333332,10.598 8.73533331,9.99999999 7.99999997,9.99999999 Z M17.3333334,14.6666667 L17.3333334,11.3333333 C17.3333334,10.598 16.7353334,9.99999999 16,9.99999999 C15.2646667,9.99999999 14.6666667,10.598 14.6666667,11.3333333 L14.6666667,14.6666667 C14.6666667,15.402 15.2646667,16 16,16 C16.7353334,16 17.3333334,15.402 17.3333334,14.6666667 Z M11.9999999,3.99999995 C7.58866664,3.99999995 3.99999995,7.58866664 3.99999995,11.9999999 L3.99999995,13.3333333 C3.99999995,13.7013333 4.29866662,13.9999999 4.66666662,13.9999999 C5.03466662,13.9999999 5.33333329,13.7013333 5.33333329,13.3333333 L5.33333329,11.9999999 C5.33333329,8.32399998 8.32399998,5.33333329 11.9999999,5.33333329 C15.676,5.33333329 18.6666667,8.32399998 18.6666667,11.9999999 L18.6666667,15.9999999 C18.6666667,17.1026667 17.7693334,17.9999999 16.6666667,17.9999999 L13.1486667,17.9999999 C12.918,17.6033334 12.4926667,17.3333334 11.9999999,17.3333334 C11.264,17.3333334 10.6666667,17.93 10.6666667,18.6666667 C10.6666667,19.4033334 11.264,19.9999999 11.9999999,19.9999999 C12.492,19.9999999 12.9173333,19.73 13.1486667,19.3333334 L16.6666667,19.3333334 C18.5046667,19.3333334 19.9999999,17.838 19.9999999,15.9999999 L19.9999999,11.9999999 C19.9999999,7.58866664 16.4113334,3.99999995 11.9999999,3.99999995 Z"
          id="path-1-support"
        ></path>
      </defs>
      <g
        id="icon-24x24px[16x16px]---line&amp;solid"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Atom/icon/communication/headset/solid">
          <mask id="mask-2-support" fill={props.color || theme.palette.grey600}>
            <use xlinkHref="#path-1-support"></use>
          </mask>
          <use
            id="Atom/icon/headset"
            fill={props.color || theme.palette.grey600}
            fillRule="nonzero"
            xlinkHref="#path-1-support"
          ></use>
          <g
            id="Group"
            mask="url(#mask-2-support)"
            fill={props.color || theme.palette.grey600}
            fillOpacity="0.6"
          >
            <g id="🎨-color">
              <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
